/*
 * @Author: summer
 * @Date: 2019-08-12 09:48:47
 * @LastEditTime: 2019-08-13 16:51:38
 * @LastEditors: Do not edit
 */
import React from "react";
import ReactDOM from 'react-dom';
import ColumnMenu from './columnMenu';
import { isFunction, isUndefined, getSysFieldid } from '@platform/api';
import Menu from '../../Menu';

require('./index.less');

const { SubMenu, ItemGroup, Item, Divider } = Menu;
//testType = "autoTest";//自动化测试
/**
 * 获取列模版的一维结构
 */
const getFactorList = ({ columns, finalFactorList }) => {
    return columns.reduce((accumulatorValue, column) => {
        //获取表格列配置
        const { children } = column;
        if (!isUndefined(children)) {
            //判断和并列的情况
            getFactorList({ columns: children, finalFactorList: accumulatorValue });
            return accumulatorValue;
        } else {
            accumulatorValue.push(column);
            return accumulatorValue;
        }
    }, finalFactorList);
};
/**
 * 在表格表体鼠标点击右键绑定事件
 * @param {*} area 表格表体的DOM(主表或者嵌套子表)
 */
function TableColSetting(param) {
    let { tableDom: area, noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, columnWidthConfig, extendRightMenu } = param;
    if (area && this.props && this.props.columns && this.table) {
        this.table.addEventListener(
            'contextmenu',
            createMouseRightMenu.bind(this, { noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, columnWidthConfig, extendRightMenu, area }),
        );

        document.addEventListener('click', removeCustomRightMenu);
    }
}

// table willunmonut remove listener add by wanglongx
function removeTableListener(removeCustomRightMenu) {
    this.eventDoms &&
        this.eventDoms.forEach(ele => {
            ele.removeEventListener('contextmenu', createMouseRightMenu);
        });
    document.removeEventListener('click', removeCustomRightMenu);
    // document.removeEventListener('contextmenu', removeCustomRightMenu);
    delete this.eventDoms;
}

//鼠标右键监听事件
function createMouseRightMenu(param, ev) {
    let isLowCode = this.props.isLowCode;
    isLowCode = false;
    let { noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, columnWidthConfig, extendRightMenu, area } = param;
    // window.getSelection().toString() 存在选中文本，使用浏览器默认菜单
    //if (window.getSelection().toString()) return;
    //若选中文本是空字符串，则自定义列设置菜单
    ev.preventDefault();
    if (!noColSetClass) {
        ev.stopPropagation();
    }
    let ischeckbox =
        ev.path &&
        ev.path.length &&
        ev.path.some(val => {
            return (
                val.nodeName === 'INPUT' &&
                val.labels &&
                val.labels[0] &&
                val.labels[0].classList &&
                val.labels[0].classList.contains('table-checkbox')
            );
        });
    let isNoSet = ev.target && ev.target.classList && ev.target.classList.contains(noColSetClass);
    removeCustomRightMenu(ev, true);
    if (!ischeckbox && !isNoSet) {
        let section = document.createElement('section');
        section.classList.add('nc-table-setColumnMenu-wrap');
        area.appendChild(section);

        ReactDOM.render(
            <div id="nc-table-setColumnMenu">
                {!isLowCode && < ul className="rightMenu" fieldid={getSysFieldid("column-right")}>
                    {extendRightMenu}
                    <ColumnMenu
                        colsSettingParam={this.props.colsSettingParam}
                        isLowCode={isLowCode}
                        extendRightMenu={extendRightMenu}
                        // columns={this.state.bodyColumn}
                        // 对多表头时的模版结构,处理成一维数组
                        columns={getFactorList({ columns: this.props.columns, finalFactorList: [] })}
                        updateColumnHandle={this.props.updateColumnHandle}
                        resetTable={this.resetTable}
                        tableScope={this}
                        cancelColSetting={cancelCustomRightMenu}
                        columnWidthConfig={columnWidthConfig}
                    />
                </ul>}
                {isLowCode &&
                    <ColumnMenu
                        colsSettingParam={this.props.colsSettingParam}
                        isLowCode={isLowCode}
                        extendRightMenu={extendRightMenu}
                        // columns={this.state.bodyColumn}
                        // 对多表头时的模版结构,处理成一维数组
                        columns={getFactorList({ columns: this.props.columns, finalFactorList: [] })}
                        updateColumnHandle={this.props.updateColumnHandle}
                        resetTable={this.resetTable}
                        tableScope={this}
                        cancelColSetting={cancelCustomRightMenu}
                        columnWidthConfig={columnWidthConfig}
                    />}
            </div >,
            section,
        );
        isFunction(colSetCallback) && colSetCallback();
        getMouseRightMenuPosition(ev, section, area);
    }
}

/**
 * 计算鼠标右键已定义菜单的位置
 */
function getMouseRightMenuPosition(ev, section, area) {
    // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
    const clickX = ev.clientX;
    const clickY = ev.clientY;
    // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    // 获取自定义菜单的宽度/高度
    const rootW = section.offsetWidth;
    const rootH = section.offsetHeight;
    // 找到最上层的modal，判断下是不是在当前modal内 modal的fixed定位会影响右键菜单的位置
    const modalList = document.querySelectorAll('.base-modal');
    const modal = modalList[modalList.length - 1];

    if(modal?.contains(area)){
        let modalLeft = modal?.childNodes?.[0]?.getBoundingClientRect()?.left || 0;
        let modalTop = modal?.childNodes?.[0]?.getBoundingClientRect()?.top || 0;
        let modalRight = modal?.childNodes?.[0]?.getBoundingClientRect()?.right || 0;
        let modalBottom = modal?.childNodes?.[0]?.getBoundingClientRect()?.height || 0;
        // 鼠标的位置坐标X+右键菜单的宽度 < modal右边到窗口左侧的距离
        // 鼠标的位置坐标Y+右键菜单的高度 < modal下边到窗口顶部的距离
        let right = clickX + rootW < modalRight;
        let left = !right;
        let bottom = clickY + rootH < modalBottom;
        let top = !bottom;
        if (right) {section.style.left = `${clickX - modalLeft}px`;}
        if (left) {section.style.left = `${clickX - modalLeft - rootW}px`;}
        if (bottom) {section.style.top = `${clickY - modalTop}px`;}
        if (top) {section.style.top = `${clickY - modalTop - rootH}px`;}
    }else{
        // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
        // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
        let right = screenW - clickX > rootW;
        let left = !right;
        let bottom = screenH - clickY > rootH;
        let top = !bottom;
        if (right) {section.style.left = `${clickX}px`;}
        if (left) {section.style.left = `${clickX - rootW}px`;}
        if (bottom) {section.style.top = `${clickY}px`;}
        if (top) {section.style.top = `${clickY - rootH}px`;}
    }
    if (screenW - clickX < 110 + 32) {
        section.classList.add('nearRight');
    }
}

export { TableColSetting, removeTableListener };
